import { Typography } from "@mui/material";
import { MprcButton, MprcRequestIndicator } from "components";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { MprcSimpleDialog } from "components/MprcSimpleDialog";
import { PublicationActionResponse, PublicationReportAnalysedInfoResponse } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";

interface IProps {
    actionId: string;
    onClose: () => void;
}

export const ModeratorMessageDialog: React.FC<IProps> = (props) => {

    const api = useCoreApi();
    const { actionId, onClose } = props;

    const [loading, setLoading] = useState<boolean>(true);
    const [actionInfo, setActionInfo] = useState<PublicationReportAnalysedInfoResponse>();

    useEffect(() => {
        api.v1.knowledgePublication.reportAnalysedInfo({ actionId })
            .then((response) => setActionInfo(response.data))
            .catch((e) => {
                MprcRequestSnackbarErrorReport(e);
                onClose();

            })
            .finally(() => setLoading(false));

    }, []);

    const { t } = useTranslation("shared");
    const navigate = useNavigate();

    return loading
        ? <MprcRequestIndicator visible />
        : <MprcSimpleDialog
            title={t("Notifications.KnowledgeRequesterReportAnalysed.Title")}
            width="xs"
            subtitle={actionInfo?.publicationTitle ?? ""}
            message={actionInfo &&
                <>
                    {t("Notifications.KnowledgeRequesterReportAnalysed.DecisionText")}&nbsp;
                    <Typography variant="overline" component="span">
                        {actionInfo.approved
                            ? t("Notifications.KnowledgeRequesterReportAnalysed.AcceptedText")
                            : t("Notifications.KnowledgeRequesterReportAnalysed.RejectedText")
                        }
                    </Typography>&nbsp;
                    {t("Notifications.KnowledgeRequesterReportAnalysed.ByModeratorText")}

                    {actionInfo.notes &&
                        <>
                            <br />
                            <br />
                            {t("Notifications.KnowledgeRequesterReportAnalysed.ModeratorMessageText")}&nbsp;
                            "{actionInfo.notes}"
                        </>
                    }
                </>
            }
            actions={
                actionInfo && actionInfo.response != PublicationActionResponse.ReportExcludePublication &&
                <MprcButton
                    variant="contained"
                    title={t("Notifications.KnowledgeRequesterReportAnalysed.ViewPublicationButtonText")}
                    onClick={() => navigate(KnowledgePaths.PublicationViewerResolver(actionInfo.publicationId, actionInfo.publicationType))}>
                    {t("Notifications.KnowledgeRequesterReportAnalysed.ViewPublicationButtonText")}
                </MprcButton>
            }
            onClose={onClose}
        />;
};
